// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Qbt9","toggleWrap":"styles_toggleWrap__1wOGR","content":"styles_content__2Q0mv","selectAreaCode":"styles_selectAreaCode__15OKC"};